var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.839844,
    width: 9.48777,
    height: 9.42863,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3472 9.99892V3.21721C13.3472 2.85994 13.0575 2.57031 12.7003 2.57031C12.343 2.57031 12.0534 2.85994 12.0534 3.21721V8.71321C12.0534 9.81777 11.1579 10.7132 10.0534 10.7132H4.50223C4.14719 10.7132 3.85938 11.001 3.85938 11.3561C3.85938 11.7111 4.14719 11.9989 4.50223 11.9989H11.3472C12.4517 11.9989 13.3472 11.1035 13.3472 9.99892Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselIcon);
export default __webpack_public_path__ + "static/media/carousel-icon.1ea1f11af0a2db89ec82bf48bcb76838.svg";
export { ForwardRef as ReactComponent };